import React, { lazy } from "react";

import type { NavigationRoutingObject } from "@navigationRouting/types";

import { AGENT_CATEGORIES } from "@lib/agentConsole";
import type { I18nT } from "@lib/dashboardI18n";

const CanvasAgentsForNRO = lazy(() =>
  import("@scenes/AgentsList").then((module) => ({
    default: () => React.createElement(module.AgentConsoleForNro, { category: AGENT_CATEGORIES.CANVAS }),
  }))
);

export const canvasAgentsNRO: NavigationRoutingObject = {
  Component: CanvasAgentsForNRO,
  noKnockoutFallback: true,
  componentFeatureFlippers: [],
  section: "agent-console",
  icon: "new-nav-system-agent-management",
  heading: (t: I18nT<"dashboard-navigation">) => t("canvas-agents-nro-heading", "Canvas Step Agents"),
  pageNameForTracking: () => "Canvas Step Agents",
  description: (t: I18nT<"dashboard-navigation">) =>
    t(
      "canvas-agents-nro-description",
      "Personalize content and decisions for each user as they move through a Canvas"
    ),
  getDeveloperNavigationAllowed: () => true,
  additionalSearchTerms: () => [],
  additionalSearchableFeatures: () => ({}),
};
